import { MessageBig } from 'components/MessageBig';

export const ErrorScreen = () => {
  return <MessageBig message={'An error has occurred'} />;
};
